import { ID, Response } from 'app/components/Table/core/types';

import { LOGIN_TYPE } from 'app/modules/auth/core/enum';

import { SecurityGroup } from '../../security-groups/core/type';

export type User = {
  id: ID;
  username: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  updatedAt: string;
  status: number;
  role: SecurityGroup;
  provider: string;
  organizationId?: number;
  organizationName?: string;
};

export type UsersQueryResponse = Response<{
  items: Array<User>;
  total: number;
}>;

export type UserRequest = {
  firstName: string;
  lastName: string;
  username?: string;
  type: LOGIN_TYPE;
  roleId: number;
  rfidCode?: string;
  email?: string;
  orgId?: number;
};

export const initialUser: User = {
  id: '',
  firstName: '',
  lastName: '',
  username: '',
  createdAt: '',
  updatedAt: '',
  status: 1,
  role: {
    description: '',
    email: '',
    id: '',
    name: '',
    type: '',
    createdAt: '',
  },
  provider: '',
};
export interface TabletFilterDetail {
  deviceId: string[];
  userId: string[];
  startTime: string | null;
  endTime: string | null;
  page: number;
}

export interface TabletFilterParams {
  deviceId?: string[] | string;
  userId?: string[] | string;
  startTime?: string | null;
  endTime?: string | null;
  page?: number;
}

export interface ActivityLog {
  id: ID;
  user_id: string;
  username: string;
  ward_id: string;
  ward_name: string;
  device_id: string;
  device_name: string;
  organization_id: string;
  organization_name: string;
  remark: string;
  episode_id: number;
  start_time: Date;
  end_time: Date;
}

export enum TAB_TABLET {
  TABLET = 1,
  ACTIVITY_LOG = 2,
}
